import ShowNewsButton from "./ShowNewsButton"
import Stepper from "../Stepper"
import Thumbnail from "../Thumbnail/Thumbnail"
import { strings as Localization } from "../../lib/Localization"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { useGetNewsQuery } from "../../redux/services/broditWebApi"
import { useSteering } from "../../redux/hook/userHooks"
import { removeTrailingSlash } from "../../lib/helper/commonHelper"
import theme from "../../theme"
import { mobileBreakpoint, tabletBreakpoint } from "../../lib/helper/viewportHelper"
import { useProxyPath } from "../../redux/hook/settingsHooks"
import { Redirect, useHistory, useRouteMatch } from "react-router-dom"

import { Skeleton } from "@material-ui/lab"
import { Box, useMediaQuery } from "@material-ui/core"
import React, { useEffect, useState } from "react"

function VehicleNewsStepper() {
    const [index] = useState(0)
    const [redirect, setRedirect] = useState(false)
    const { url } = useRouteMatch()
    const history = useHistory()
    const proxyPath = useProxyPath()
    const language = useLanguage()
    const steering = useSteering()
    const isSmall = useMediaQuery(theme.breakpoints.down(tabletBreakpoint))
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint + 200))
    let steeringGroup
    let limit
    if (isMobile) {
        limit = 1
    } else if (isSmall) {
        limit = 2
    } else {
        limit = 4
    }

    switch (steering) {
        case "1":
            steeringGroup = "LHD"
            break
        case "2":
            steeringGroup = "RHD"
            break
        default:
            steeringGroup = "LHD"
    }

    const { data: vehicleNews, isFetching } = useGetNewsQuery({
        language,
        limit: limit,
        groups: [steeringGroup]
    })

    useEffect(() => () => {
        setRedirect(false)
    })

    return (
        <Box id="vehicleNewsStepper">
            {redirect && <Redirect to={`${removeTrailingSlash(url)}/proclip`} />}
            <Stepper
                style={{
                    margin: 45
                }}
                pages={
                    [
                        <Box
                            key="-"
                            style={{
                                display: "flex"
                            }}
                            spacing={5}
                        >
                            {
                                !isFetching && vehicleNews
                                && vehicleNews.map(news => (
                                    <Thumbnail
                                        key={news.id}
                                        style={{ marginRight: 45, flexGrow: 1 }}
                                        href={`/product/${news.products?.[0]}`}
                                        src={news.images?.[0]}
                                        alt={`${Localization.product} ${news.products?.[0]}`}
                                        srcWidth="310"
                                    />
                                ))
                            }
                            {
                                isFetching
                                && [...Array(4).keys()].map(i => (
                                    <Skeleton
                                        key={i}
                                        style={{ marginRight: 45, flexGrow: 1, height: 100 }}
                                    />
                                ))
                            }
                        </Box>
                    ]
                }
                index={index}
                setIndex={() => { }}
                nextButtonComponent={ShowNewsButton}
                backButtonComponent={() => null}
                handleNext={() => { history.push(`${proxyPath}/${language}`); setRedirect(true) }}
                disabledSwipe
            />
        </Box>
    )
}

// Accidentally created miniature image example
/*
import { NavigationButton, StepNavigation } from '../Stepper';
import { Skeleton } from '@material-ui/lab';

<StepNavigation
    items={vehicleNews}
    selectedIndex={index}
    handleStepChange={(i) => setIndex(i)}
    stepComponent={MiniatureImage}
/>

function MiniatureImage({ item, index, selected, ...props }) {
    return (
        <Box
            style={{
                boxSizing: "border-box",
                width: 50,
                height: 50,
                border: (selected) ? '1px solid grey' : ''
            }}
            {...props}
        >
            <img width="100%" height="100%" src={item.image} />
        </Box >
    )
}
*/

export default VehicleNewsStepper
